import { gql } from "@apollo/client"
import { mutate } from "lib/graphql/mutate"

export async function createNewSchedule(definition) {
    return mutate(
        gql`
            mutation create($definition: ScheduleCreator!) {
                createNewSchedule(definition: $definition)
            }
        `,
        { definition },
        { returns: "createNewSchedule" }
    )
}
